import { Link } from "@remix-run/react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer
            aria-labelledby="footer-heading"
            className="relative mt-20 overflow-hidden border-t border-white/10 bg-[#070b14] px-4 pb-10 pt-10 sm:mt-28 sm:px-8"
        >
            <div aria-hidden className="pointer-events-none absolute -top-24 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-emerald-400/10 blur-3xl" />
            <div aria-hidden className="pointer-events-none absolute -right-20 bottom-8 h-48 w-48 rounded-full bg-cyan-400/10 blur-3xl" />
            <div className="relative mx-auto max-w-7xl rounded-2xl border border-white/10 bg-white/[0.03] p-6 shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_70px_rgba(0,0,0,0.6)] backdrop-blur-xl sm:p-8">
                <h2 id="footer-heading" className="sr-only">
                    Footer
                </h2>
                <div className="mb-6 flex justify-start md:justify-end">
                    <Link
                        to="/about"
                        className="inline-flex items-center rounded-full border border-emerald-300/40 bg-emerald-400/10 px-4 py-2 text-sm font-semibold text-emerald-200 transition-colors hover:bg-emerald-400/20 hover:text-emerald-100 focus-visible:bg-emerald-400/20 focus-visible:text-emerald-100"
                    >
                        About MDFYI
                    </Link>
                </div>
                <div className="grid gap-8 md:grid-cols-3 md:gap-10">
                    <div>
                        <span className="inline-flex items-center rounded-full border border-emerald-300/30 bg-emerald-400/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-200">
                            Investor Research Platform
                        </span>
                        <p className="mt-4 text-lg font-semibold text-white">MarketDataFYI</p>
                        <p className="mt-3 max-w-sm text-sm leading-6 text-slate-300">
                            Research investors use to evaluate businesses with transparent assumptions,
                            traceable sources, and practical valuation context.
                        </p>
                    </div>
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-200">Legal</p>
                        <ul className="mt-3 space-y-2.5 text-sm text-slate-300">
                            <li>
                                <Link to="/terms" className="inline-flex items-center transition-colors hover:text-emerald-300 focus-visible:text-emerald-300">
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="inline-flex items-center transition-colors hover:text-emerald-300 focus-visible:text-emerald-300">
                                    Privacy Policy
                                </Link>
                            </li>
                            {/* <li>
                                <Link to="/data-sources" className="inline-flex items-center transition-colors hover:text-emerald-300 focus-visible:text-emerald-300">
                                    Data Sources & Methodology
                                </Link>
                            </li> */}
                        </ul>
                    </div>
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-200">Disclosure</p>
                        <p className="mt-3 text-xs leading-6 text-slate-300">
                        MarketDataFYI is an independent research and data platform. All content is provided for informational purposes only and does not constitute financial, investment, or legal advice. MarketDataFYI is not a registered investment adviser. Nothing on this platform should be construed as a recommendation to buy, sell, or hold any security. Data is sourced from third-party providers and while we strive for accuracy, we make no guarantees regarding completeness, timeliness, or reliability. Always conduct your own due diligence and consult a qualified financial professional before making investment decisions. Past performance is not indicative of future results.
                        </p>
                    </div>
                </div>
                <p className="mt-8 border-t border-white/10 pt-6 text-center text-sm leading-5 text-slate-400">
                    &copy; {currentYear} MarketDataFYI, Inc. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;